export const MAX_QUERY_SIZE = 512;
export const ASK_AI_API_URL = 'https://askai.algolia.com/chat';
export const USE_ASK_AI_TOKEN = true;
